module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--session-384bd4690df786b9d14ae66beafa32cf.svg";